export async function forgottenPassword(email: string): Promise<boolean> {
    try {
        const response = await fetch('/operations/admin/AJAX-REQUESTS-General.aspx/Forgotten_Password_Reset', {
            body: JSON.stringify({
                Email_Address: email
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });

        const body = await response.json();
        return parseInt(body.d) === 1;
    } catch (error) {
        console.error(error);
    }

    return false;
}
